import { DocumentFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type OperationsAdminVenueDocumentCreateFragment = Omit<DocumentFragment, 'id' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'talent' | 'talent_id' | 'status' | 'role'| 'document_status' | 'document_type' >

export const OperationsAdminVenueDocumentCreateSchema: FormSchema<OperationsAdminVenueDocumentCreateFragment> = {
    id: "document",
    title: "Document Date",
    groups: {
        default: {
            label: 'Default' 
        }
    },
   fields: {
        type: {
            group: 'default',
            label: "Type",
            type: "document-type-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        url: {
            group: 'default',
            label: "Upload File/s",
            type: "talent-asset-upload",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        },
        filename: {
            group: 'default',
            label: "Filename",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            },
            skipRender: true
        },
        size: {
            group: 'default',
            label: "Filesize",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            },
            skipRender: true
        },
        filetype: {
            group: 'default',
            label: "Filetype",
            type: "text",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            },
            skipRender: true
        }
    }
}

export type OperationsAdminVenueDocumentUpdateFragment = Omit<DocumentFragment, 'id' | 'created_at' | 'updated_at' | 'created_by_user' | 'updated_by_user' | 'talent' | 'talent_id' | 'role'| 'type' | 'document_status' | 'document_type'  >

export const OperationsAdminVenueDocumentUpdateSchema: FormSchema<OperationsAdminVenueDocumentUpdateFragment> = {
    id: "document",
    title: "Document Date",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        status: {
            group: 'default',
            label: "Status",
            type: "document-status-select",
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        }
    }
}